<template>
  <div
    class="py-20 lg:py-32 px-12 sm:px-16 lg:px-20 flex items-center justify-center w-full overflow-hidden gradient-bg"
  >
    <div
      class="flex w-full max-w-6xl flex-wrap lg:flex-nowrap text-white justify-center relative"
    >
      <img
        class="absolute left-0 top-1/2 w-full lg:w-1/3 opacity-10 filter brightness-0 invert"
        src="/img/cw-marketing/cw-shapes_dots.svg"
        alt="CW alt shapes"
      />
      <div class="w-full lg:w-1/2 lg:pr-44 relative">
        <h2
          class="font-montserrat font-bold text-4xl mb-8 lg:mb-2 text-center lg:text-left"
        >
          {{ item.title }}
        </h2>
        <p v-if="item.text" class="text-white text-center lg:text-left text-lg">
          {{ item.text }}
        </p>
        <button
          v-if="item.buttonText"
          class="m-0 btn btn-cw-alt font-nunito shadow-lg mt-12"
          @click="showOrgRegistrationModal"
        >
          {{ item.buttonText }}
        </button>
      </div>
      <div class="flex items-center w-10/12 lg:w-1/2 pt-8 sm:pt-0">
        <!-- Display image or stats -->
        <div
          v-if="!item.image"
          class="w-full justify-around lg:justify-between flex flex-col sm:flex-row"
        >
          <div
            v-for="(stat, i) in item.stats"
            :key="i"
            :class="[
              'flex flex-col sm:mb-0',
              { 'mb-12': i !== item.stats.length - 1 },
            ]"
          >
            <h2 class="font-montserrat text-center text-5xl">
              {{ stat.numbers | abbr }}+
            </h2>
            <h6 class="font-nunito uppercase text-sm text-center">
              {{ stat.name }}
            </h6>
          </div>
        </div>
        <img v-else :src="item.image" alt="illustrations" />
        <div
          v-if="partners"
          class="pt-12 relative flex justify-center space-x-4 lg:justify-end overflow-y-hidden"
        >
          <div
            v-for="(partner, i) in partners.slice(0, 6)"
            :key="i"
            class="w-16 h-16 flex-shrink-0 bg-contain flex justify-center items-center relative"
          >
            <a
              :href="partner.site_url"
              class="w-full h-full absolute top-0 left-0"
            >
              <img
                :src="partner.logo"
                :alt="partner.id"
                class="w-full h-full rounded-xl shadow-lg"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from '../../../js/plugins/event-bus.js'
import { mapGetters } from 'vuex'

export default {
  filters: {
    abbr: function (num) {
      if (String(num).length > 6) {
        return Math.round(num / 100000) / 10 + 'M'
      } else {
        if (String(num).length > 3) {
          return Math.round(num / 1000) + 'K'
        }
        return num
      }
    },
  },

  props: {
    item: {
      type: Object,
      default: () => {},
    },

    partners: {
      default: null,
    },
  },

  computed: {
    ...mapGetters({
      cloudURL: 'shared/getCloudURL',
    }),
  },

  methods: {
    showOrgRegistrationModal() {
      EventBus.$emit('showModal', {
        action: 'cw-organisation-registration',
      })
    },
  },
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@700;900&display=swap');

/* animated gradient BG */
.gradient-bg {
  background: linear-gradient(-45deg, #6f36bc, #ff4778, #6d28d9, #db2777);
  background-size: 400% 400%;
  animation: gradient 10s ease infinite;
}

@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }

  50% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0% 50%;
  }
}
</style>
